export const cols = [{
	prop: 'linkman',
	label: '联系人',
	width: '180',
	align: 'center',
	show: true
}, {
	prop: 'tel',
	label: '联系电话',
	width: '130',
	align: 'center',
	show: true
}, {
	prop: 'stopflag',
	label: '店铺状态',
	width: '100',
	align: 'center',
	show: true
}, {
	prop: 'shopState',
	label: '店铺营业状态',
	width: '100',
	align: 'center',
	show: true
}, {
	prop: 'id',
	label: 'id',
	width: '180',
	align: 'center',
	show: false
}]
// {
// 	prop: 'code',
// 	label: '店铺编号',
// 	width: '180',
// 	align: 'center',
// 	show: true
// }, {
// 	prop: 'name',
// 	label: '店铺名称',
// 	width: '180',
// 	align: 'center',
// 	show: true
// }
